import LocalStorageService from './storage/local-storage-service';

class ConfigService {
  /**
   * class constructor method
   */
  constructor() {
    /**
     * Application version
     * @type {number}
     */
    this.version = 1.0;
    /**
     * All available endpoints
     */
    this.endpoints = {
      layoutSource: 'rest/FELayout/GetLayoutSettings',
      allLayouts: 'rest/FELayout/LayoutSettings',
      languageResource: process.env.VUE_APP_IS_AGENT ? 'rest/FEAHome/LanguageResources' : 'rest/FEWHome/LanguageResources',
      fixtureMenu: 'rest/FEWFixture/FixturesMenu',
      betBuilderFixtureMenu: 'rest/FEMobile/GetFixturesMenuBB',
      sportsMenu: 'rest/FEWFixture/FixtureSports',
      getUpcoming: 'rest/FEWHome/Upcoming',
      getHighlights: 'rest/FEWHome/Highlights',
      liveMatches: 'rest/FEWHome/GetLiveMatchesMetaData',
      liveMatchesMobile: 'rest/FEMobile/GetLiveMatchesMetaData',
      categoryMatches: 'rest/FEWFixture/GroupedMatches',
      betBuilderTournamentMatches: 'rest/FEMobile/GetGroupedMatchesBB',
      categoryMatchesList: 'rest/FEMobile/GetGroupedMatches',
      categoryOutrights: 'rest/FEWFixture/CategoryOutrights',
      tournamentOutrights: 'rest/FEWFixture/TournamentOutrights',
      horseRacingOutrights: 'rest/FEWFixture/TournamentOutrightsHorseRacing',
      horseRacingSportOutrights: 'rest/FEWFixture/GetNextRaces',
      hrCategoryMenu: 'rest/FEWFixture/GetHRCategoriesMenu',
      hrTimeFilter: 'rest/FEWFixture/GetTodaysRacesHorseData',
      hrRaceOddDetails: 'rest/FEWFixture/GetOutrightRace',
      search: 'rest/FEWHome/SearchEventsByName',
      mybets: 'rest/FEWBetSlip/History',
      checkCashout: 'rest/FEWBetSlip/CheckCashout',
      mybetsDetails: 'rest/FEWBetSlip/HistoryDetails',
      winningsDetails: 'rest/FEWHome/WinningsDetails',
      myfavorites: 'rest/FEWHome/GetFavouriteMatches',
      getWebManifest: 'rest/FEWPlayer/LCGetDesktopStream',
      placebet: 'rest/FEWBetslip/Place', // FEWBetslip/Place no userid required
      incompatibility: 'rest/Betslip/CheckItemForIncompatibility',
      game: 'rest/FEMobile/GetMatchDetailOdds',
      playerOdds: 'rest/FEMobile/GetMatchPlayerOdds',
      getUserFreebets: 'rest/FEWFreeBet/UserFreeBets', // FEWFreeBet/UserFreeBets [GET]
      settings: 'rest/FEWHome/AllSettings',
      checkBetslip: 'rest/FEWHome/CheckBetslip', // FEWBetslip/Check [GET]
      checkBetslipAgent: 'rest/FEABetSlip/CheckBetslip',
      BookBetslip: 'rest/ReserveBetSlip/Reserve',
      LoadBetslip: 'rest/ReserveBetSlip/Retrieve',
      matchMetadata: 'rest/FEMobile/GetMatchTabs',//'rest/FEWMatches/MatchTabsFirst',
      matchOdds: 'rest/FEWMatches/MatchOdds',
      calculateBonus: 'rest/FEWBetslip/CalculateBonus', // FEWBetslip/CalculateBonus
      scorecast: 'rest/FEWMatches/MatchOddsScorecast',
      betSlipOffer: 'rest/FEWBetslip/BetslipOffer', // FEWBetslip/BetslipOffer
      getAllSports: 'rest/FEWFixture/Sports',
      affiliateUsersHist: 'rest/FEWBetslip/GetAffiliateUsersHist', // no userid in params
      playerInfo: 'rest/FEWPlayer/PlayerInfo', // FEWBetslip/PlayerInfo  //no userid in params
      // sb-front specific endpoints:
      virtualTennisFixtures: 'rest/Fixtures/GetFixturesVTOMatches',
      topWinnings: 'rest/FEWHome/TopWinnings',
      matchCode: 'rest/FEWHome/MatchByEventID',
      matchOddsForMarket: 'rest/FEWHome/MatchOddsForMarket',
      sportTabs: 'rest/FEWFixture/SportTabs',
      tournamentOdds: 'rest/FEWFixture/TournamentMatchOdds',
      bonuses: 'rest/FEWBetslip/GetUserBonuses', // no parameters
      wageredBonus: 'rest/FEWBetslip/SetUserWageredBonus', // no userid in params
      printOdds: 'rest/FEWFixture/CategoryPrint',
      sportsCombo: 'rest/FEWHome/MainWidgetMarkets',
      sportsMarketsUs: 'rest/FEWHome/GetPositionOddTypes',
      printTicketLogo: 'rest/FEWFixture/PrintTicketLogo',
      printFixtureLogo: 'rest/FEWFixture/PrintFixtureLogo',
      liveChannelOnline: '/rest/FEWHome/LCGetStreamedMatches',
      liveStreamingAll: '/rest/FEWHome/LCGetShortStreamedMatches',
      upcomingFixture: 'rest/FEWFixture/UpcomingFixture',
      betSlipCashout: 'rest/FEWBetslip/Cashout', // FEWBetslip/Cashout  - no userid in params
      onlineShop: 'rest/OnlineShop/SetPermissions',
      setPermissions: 'rest/OnlineShop/SetPermissions',
      getAffiliateUsers: 'rest/FEWBetslip/GetAffiliateUsers', // no params
      seenNotify: 'rest/FEWNotification/Seen', // FEWNotification/Seen
      getBonusBrands: 'rest/FEWBetslip/GetBonusBrands',
      getBonusRules: 'rest/FEWBetslip/GetAccumulatorBonusRules',
      // fixtureMenu: 'rest/FEMobile/GetFixturesMenu',
      // sportsMenu: 'rest/FEMobile/GetFixturesSports',
      // mybets: 'rest/FEWBetSlip/BetslipsHistory',

      // setPermissions: '/onlineshop/SetPermissions',
      cancelPlacedBetslip: 'rest/FEABetSlip/CancelGroup',
      searchUser: 'rest/FEABetSlip/SearchUser',
      outrightsDetails: 'rest/FEWFixture/OutrightDetails',
      sportOutrights: 'rest/FEWFixture/SportOutrights',
      paidBetslip: 'rest/FEABetSlip/Paid',

      // agent mobile
      mybetsMobile: 'rest/Mobile/GetBetSlipsForUser',
      mybetsNewFormat: 'rest/FEMobile/BetslipsHistoryES',
      mybetsDetailsMobile: 'rest/Mobile/GetBetSlipForUser',
      checkBetslipMobile: 'rest/Mobile/CheckBetslip',
      betSlipOfferMobile: 'rest/Betslip/BetSlipOffer',
      betSlipCashoutMobile: '/rest/Betslip/BetSlipCashoutAsync',
    };
    /**
     * All mock data can be set here
     * @type {}
     */
    this.widgetData = {
      'rest/FEMobile/GetFixturesMenu': 'fixutre-menu-model.json',
    };
    /**
     * default headers used on lot of requests
     */
    this.defaultHeaders = {
      Culture: process.env.VUE_APP_IS_AGENT ? LocalStorageService.get('locale') || APP_SETTINGS.player.language : APP_SETTINGS.player.language
    };
    /**
     * custom headers
     */
    this.authorizationHeaders = {
      Provider: APP_SETTINGS.settings.userProviderId || 0,
      Token: APP_SETTINGS.player.token,
    };

    this.customHeaders = {
      connectionId: '',
    };
  }
}

/**
 * We are exporting the config service here so we can use single instance try all app
 */
export default new ConfigService();
